<form [formGroup]="attachmentsForm" class="mydocma-form at-form">
  <!-- <mydocma-upload-and-preview [files]="files" [canDropInPreviews]="true" [acceptedTypes]="acceptedTypes"
    (filesAdded)="onFilesAdded($event)" (fileDeleted)="onFileDeleted($event)">
  </mydocma-upload-and-preview> -->

   <ng-container *ngIf="files && files.length>0" >
    <ng-container *ngIf="files.length < 2">
      <div class="at-form-group" (click)="descriptionExpanded=!descriptionExpanded">
        <div class="at-form-group-title">
          {{'MM.attachment.descriptionGroup' | translate }}
        </div>
        <button mat-icon-button>
          <mat-icon>{{!descriptionExpanded ? 'expand_more' : 'expand_less'}}</mat-icon>
        </button>
      </div>
      <ng-container *ngIf="descriptionExpanded" >
        <mydocma-dynamic-form
          [formConfig]="addAttachmentsFormService?.formConfig$ |async"
          (ready)="onFormReady($event)">
        </mydocma-dynamic-form>
      </ng-container>
    </ng-container>
    <mat-form-field style="width: 100%;">
      <mydocma-previews [files]="files" (fileDeleteClicked)="onFileDeleted($event)">
      </mydocma-previews>
      <input type="text" matInput hidden formControlName="files">
      <mat-error>{{ 'MM.attachment.errors.noFileAdded' | translate }}</mat-error>
    </mat-form-field>
  </ng-container>
  <mydocma-file-drag-drop
       [selectFileStrategies]="fileStrategies"
          (filesAdded)="onFilesAdded($event)"
          [acceptedTypes]="acceptedTypes"
          [isMobile]="mobileMode">
  </mydocma-file-drag-drop>
</form>
